import script from "./CalendarViewSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarViewSwitch.vue?vue&type=script&setup=true&lang=js"

import "./CalendarViewSwitch.vue?vue&type=style&index=0&id=76970f7f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76970f7f"]])

export default __exports__